import { createAction, createSlice } from '@reduxjs/toolkit';
import { BaseTokenModel, decodeJwt } from '../../utils/jwtDecoder.ts';

// Initial state for user state
const initialState: any = {
  loading: 0,
  token: undefined,
  tenantId: undefined,
  user: {} as BaseTokenModel,
};

/**
 * Sets the user token in the store and decodes it to get the user data
 */
export const setUserToken = createAction<string>('user/setToken');

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUserToken, (state, action) => {
      if (state.token === action.payload) {
        // no actual token change, ignore the action
        return;
      }

      state.token = action.payload;

      if (action.payload) {
        state.user = decodeJwt(action.payload);
        state.roles = state.user?.roles;
      }
    });
  },
});

export default userSlice.reducer;
